export const I18N = {
    de: {
        close: 'Schließen',
        cancel: 'Abbrechen',
        agree: 'Zustimmen',
    },
    en: {
        close: 'Close',
        cancel: 'Cancel',
        agree: 'Agree',
    },
};
